/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import { StateStoring } from 'devextreme-react/data-grid';
import { createReducer } from 'reduxsauce';
import { tableItemFlags } from '../../../constants';
import { Types } from './action';

const INITIAL_STATE = {
  equipmentsData: [],
  equipmentsMeta: {},
  equipmentsCount: null,
  //   usersUploadedData: [],
  searchQueries: {},
  //   valueForOutline: [],
  equipmentPermissions: {},
  loading: false,
  error: null
};

const getEquipmentsListStart = (state = INITIAL_STATE, action) => ({
  ...state,
  loading: true
});
const getEquipmentsListSuccess = (state = INITIAL_STATE, action) => {
  const { data, meta, Count, equipmentPermissions } = action.payload;
  return {
    ...state,
    equipmentsData: data,
    equipmentsMeta: meta,
    equipmentsCount: Count,
    equipmentPermissions,
    loading: false
  };
};
const getEquipmentsListFailure = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;
  return {
    ...state,
    error,
    loading: false
  };
};

const setSearchQueries = (state = INITIAL_STATE, action) => ({
  ...state,
  searchQueries: { ...action.payload }
});

const HANDLERS = {
  [Types.GET_EQUIPMENTS_LIST_START]: getEquipmentsListStart,
  [Types.GET_EQUIPMENTS_LIST_SUCCESS]: getEquipmentsListSuccess,
  [Types.GET_EQUIPMENTS_LIST_FAILURE]: getEquipmentsListFailure,

  [Types.SET_SEARCH_QUERIES]: setSearchQueries
};

export const EquipmentsReducer = createReducer(INITIAL_STATE, HANDLERS);
